import common from './de/pages/common';
import auth from './de/pages/auth';
import dashboard from './de/pages/dashboard';
import tasks from './de/pages/tasks';
import guests from './de/pages/guests';
import budget from './de/pages/budget';
import timeline from './de/pages/timeline';
import vendors from './de/pages/vendors';
import account from './de/pages/account';
import subscription from './de/pages/subscription';
import notifications from './de/pages/notifications';
import events from './de/pages/events';
import languages from './de/pages/languages';
import settings from './de/pages/settings';

import legal from './de/pages/legal';
import achievements from './de/pages/achievements';
import invitation from './de/pages/invitation';
import theme from './de/theme';
import taskTemplates from './de/taskTemplates';
import debug from './de/debug';

export default {
  ...common,
  common,
  currentEvent: "Aktuelle Veranstaltung",
  auth,
  dashboard,
  tasks,
  guests,
  budget,
  timeline,
  vendors,
  account,
  subscription,
  notifications,
  events,
  languages,
  ...settings,
  legal,
  achievements,
  invitation,
  theme: {
    ...theme,
    light: "Hell",
    dark: "Dunkel",
    system: "System"
  },
  taskTemplates,
  debug
};
